export default "/images/attendance-medium.svg?fa469979a45c68ba237c61f550ba7201";